import TimezoneOptions from '../../../../assets/settings/timezones.json';

export class Timezone {
  label: string;
  tzCode: string;
  name: string;
  utc: string;
  tzOffset?: number;

  constructor(label: string, tzCode: string, name: string, utc: string, tzOffset: number) {
    this.label = label;
    this.tzCode = tzCode;
    this.name = name;
    this.utc = utc;
    this.tzOffset = tzOffset;
  }

  static options(): Timezone[] {
    return TimezoneOptions;
  }

  // static getTimezoneOffset(timeZone: string): number {
  //   const str = new Date().toLocaleString('en', {timeZone, timeZoneName: 'longOffset'});
  //   const [_,h,m] = str.match(/([+-]\d+):(\d+)$/) || [, '+00', '00'];
  //   return +h * 60 + (+h > 0 ? +m : -m);
  // }

  // dateToLocalISO(date: Date, timezone?: string): string {
  //   const off = Timezone.getTimezoneOffset(timezone!) || date.getTimezoneOffset();
  //   const currentOff = -date.getTimezoneOffset();
  //   const absoff = Math.abs(off);
  //   return (new Date(date.getTime() - ((+off*60*1000) - (+currentOff*60*1000))).toISOString().substr(0,23) +
  //           (off > 0 ? '+' : '-') + 
  //           Math.floor(absoff / 60).toFixed(0).padStart(2,'0') + ':' + 
  //           (absoff % 60).toString().padStart(2,'0'))
  // }

}